
  import { Component, Vue ,Prop ,Watch } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import * as echarts from 'echarts';
  @Component({  
    name: '',
    components: {
      PageFooter,
    }
  })

  export default class ProductList extends Vue {
    @Prop({default:()=>{return []}}) data:any
    @Prop({default:()=>{return {value:'value',name:'name'}}}) option!:any
    @Prop() title!:any
    @Prop({default:()=>{return []}}) lines:any
    @Prop({default:''}) yaxislabel!:any
    @Watch('data')
    private watchdata(){
      this.$nextTick(()=>{
        this.initcharts()
      })
    }

    private key = Math.random()

    private mounted () {
    // console.log(this.option) 
      this.$nextTick(()=>{
        this.initcharts()
      })
    }
    private clearChart(){
      let myChart = echarts.init(document.getElementById('charts'+this.key))
      myChart.clear()
      myChart.setOption({})
    }
    private initcharts(){
      let chartDom = document.getElementById('charts'+this.key);
      let myChart = echarts.init(chartDom);
      let option = {
        // title: {
        //   text: this.title,
        //   subtext: 'Fake Data',
        //   left: 'center',
        // },
        tooltip: {
          trigger: 'item',
        },
        legend: {
          bottom:'0%',
          left: 'center',
        },
        yAxis: {
          type: 'value',
          minInterval:1,
          axisLabel:{
            formatter:'{value} ' + this.yaxislabel
          }
        },
        xAxis: {
          type: 'category',
          data: this.data.map(v=>v.Name)
        },
        series: [],
      };

      option.series = this.lines.map(v=>{
        let val:any = {
          name:v.name,
          type:'bar',
          data:[],
          itemStyle:{
            normal:{
              label:{
                show:true,
                position:'top'
              },
              barBorderRadius:[5,5,0,0]
            }
          }
        }
        val.data = this.data.map(x=>{
          return {
            value:x[v.key],
            name:v.name,
          }
        })
        // console.log(val.data)
        return val
      })
      // console.log(this.lines)
      // console.log(option.series)
      option && myChart.setOption(option);
    }
  }
